"use client";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Chip, IconButton, useTheme } from "@mui/material";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import { formatDateTimeToDDMMYYYYHHMMSS } from "@/helpers/date-helpers";
import { IServiceInterface } from "@/interfaces/service-interface.interface";
import { ServiceInterfaceMessages } from "@/messages/service-interface/service-interface.messages";

type Props = {
  item: IServiceInterface;
  index: number;
  messages: ServiceInterfaceMessages;
  onOpenPopover: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    item: IServiceInterface
  ) => void;
};

const formatBoolean = (value: boolean, messages: ServiceInterfaceMessages) =>
  value ? messages.yesLabel : messages.noLabel;

const getPlatformLabel = (
  item: Pick<IServiceInterface, "platformDisplayName" | "platformName">,
  fallback: string
) => item.platformDisplayName?.trim() || item.platformName?.trim() || fallback;

export function ServiceInterfaceTableRow({ item, index, messages, onOpenPopover }: Props) {
  const theme = useTheme();
  const hasErrors = item.countErrors > 0;

  const formattedLastExecution = item.lastExecution
    ? formatDateTimeToDDMMYYYYHHMMSS(item.lastExecution)
    : "—";

  return (
    <TableRow
      index={index}
      sx={
        hasErrors
          ? { backgroundColor: `${theme.palette.error.main}14` }
          : undefined
      }
    >
      <TableCell>{getPlatformLabel(item, messages.internalPlatformLabel)}</TableCell>
      <TableCell>{item.description}</TableCell>
      <TableCell>{formatBoolean(item.isActive, messages)}</TableCell>
      <TableCell>{item.intervalInSeconds}</TableCell>
      <TableCell>{formattedLastExecution}</TableCell>
      <TableCell>{formatBoolean(item.isRunning, messages)}</TableCell>
      <TableCell>{formatBoolean(item.isPaused, messages)}</TableCell>
      <TableCell>
        {hasErrors ? (
          <Chip label={item.countErrors} color="error" size="small" />
        ) : (
          item.countErrors
        )}
      </TableCell>
      <TableCell>{item.countSuccess}</TableCell>
      <TableCell>
        <IconButton onClick={(e) => onOpenPopover(e, item)}>
          <MoreHorizIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
